<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 2C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V9C20 9.55228 19.5523 10 19 10H13C12.4872 10 12.0645 9.61396 12.0067 9.11662L12 9L11.999 4H7C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H14ZM15.7071 14.2929L18 16.585L20.2929 14.2929C20.6534 13.9324 21.2206 13.9047 21.6129 14.2097L21.7071 14.2929C22.0676 14.6534 22.0953 15.2206 21.7903 15.6129L21.7071 15.7071L19.415 18L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L18 19.415L15.7071 21.7071C15.3466 22.0676 14.7794 22.0953 14.3871 21.7903L14.2929 21.7071C13.9324 21.3466 13.9047 20.7794 14.2097 20.3871L14.2929 20.2929L16.585 18L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929ZM13.999 4.414L14 8H17.586L13.999 4.414Z"
    fill="currentColor"
  />
</svg>
